<template>
  <div class="team-members-display" @click.stop>
    <span v-if="!memberList.length" class="empty-text">{{ emptyText }}</span>
    <template v-else>
      <a-tag
        v-for="(name, index) in memberList"
        :key="index"
        class="display-tag"
        :title="name"
      >
        {{ name }}
      </a-tag>
    </template>
  </div>
</template>

<script>
export default {
  name: "TeamMembersDisplay",
  props: {
    value: { type: String, default: "" },
    emptyText: { type: String, default: "-" },
  },
  computed: {
    memberList() {
      if (!this.value || this.value === "-") return [];
      return String(this.value)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
  },
};
</script>

<style scoped lang="scss">
.team-members-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 2px 0;
}
.empty-text {
  color: #999;
}
.display-tag {
  margin: 0;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 22px;
  border-radius: 4px;
  background: #f0f6ff;
  border-color: #d6e4ff;
  color: #9A0B00;
}
</style>
